"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Visibility = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const visibility_style_1 = __importDefault(require("./visibility.style"));
const visibility_icon_1 = __importDefault(require("./visibility.icon"));
const invisible_1 = __importDefault(require("../../invisible/invisible"));
const generic_1 = __importDefault(require("../generic"));
const Visibility = ({ classes, onClick, checked, label, text, checkedText, subjectId, buttonRef, disabled }) => {
    const id = lodash_uniqueid_1.default('vis_');
    const rootProps = {
        className: classes.root
    };
    const buttonProps = {
        onClick,
        label: checked ? checkedText : text,
        role: 'switch',
        'aria-checked': checked,
        'aria-controls': subjectId,
        disabled,
        ref: buttonRef,
        id
    };
    return (jsx_runtime_1.jsxs("label", Object.assign({ htmlFor: id }, rootProps, { children: [jsx_runtime_1.jsx(invisible_1.default, { children: label }, void 0),
            jsx_runtime_1.jsx(generic_1.default, Object.assign({}, buttonProps, { color: "grey3" }, { children: jsx_runtime_1.jsx(visibility_icon_1.default, {}, void 0) }), void 0)] }), void 0));
};
exports.Visibility = Visibility;
exports.Visibility.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    checked: prop_types_1.default.bool.isRequired,
    label: prop_types_1.default.string,
    text: prop_types_1.default.string,
    checkedText: prop_types_1.default.string,
    buttonRef: prop_types_1.default.func,
    subjectId: prop_types_1.default.string,
    disabled: prop_types_1.default.bool
};
exports.Visibility.defaultProps = {
    label: 'Toggle visibility',
    text: 'show',
    checkedText: 'hide',
    subjectId: null,
    disabled: false,
    buttonRef: () => { }
};
exports.default = react_jss_1.default(visibility_style_1.default)(exports.Visibility);
//# sourceMappingURL=visibility.js.map